(function () {
  var UA_CODE = 'UA';
  var UA_REDIRECT_AUTO_ENABLED = false;
  if (UA_REDIRECT_AUTO_ENABLED === null || UA_REDIRECT_AUTO_ENABLED === undefined) {
    UA_REDIRECT_AUTO_ENABLED = true;
  }
  var IPINFO_TOKEN = 'a4ed0da0ea3114';
  var UA_REDIRECT_ENABLED = true;
  var UA_REDIRECT_URL = "https:\/\/litkovska.com\/";
  var REDIRECT_DELAY_MS = (12 || 0) * 1000;
  var ALLOW_STAY = true;
  var BYPASS_PARAM = 'stayInternational';
  var STORAGE_KEY = 'ua-redirect-bypass';
  var COPY = {
    title: "You’re visiting from outside Ukraine",
    body_prefix: "We’ll redirect you to the international version of our website in",
    body_suffix: "12 seconds for a better experience.",
    body_no_auto: "You can switch to the international website now.",
    btn_stay: "Stay on Ukrainian site",
    btn_go: "Go to international site"
  };

  function getCountry() {
    var code = document.body.getAttribute('data-visitor-country') || '';
    return code.trim().toUpperCase();
  }

  function detectCountry() {
    var countryFromAttr = getCountry();
    if (!window.fetch) return Promise.resolve(countryFromAttr);

    var url = 'https://ipinfo.io/json?token=' + encodeURIComponent(IPINFO_TOKEN);

    return fetch(url, { cache: 'no-store' })
      .then(function (res) { return res.ok ? res.json() : {}; })
      .then(function (data) {
        if (data && data.country) return String(data.country).trim().toUpperCase();
        return countryFromAttr || '';
      })
      .catch(function () { return countryFromAttr || ''; });
  }

  function hasBypass() {
    try { return localStorage.getItem(STORAGE_KEY) === 'true'; }
    catch (e) { return false; }
  }

  function setBypass() {
    try { localStorage.setItem(STORAGE_KEY, 'true'); } catch (e) {}
  }

  function handleBypassParam() {
    var params = new URLSearchParams(window.location.search);
    if (!params.has(BYPASS_PARAM)) return false;
    setBypass();
    params.delete(BYPASS_PARAM);
    var newSearch = params.toString();
    var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
    return true;
  }

  function buildModal(visitorCountry) {
    var modal = document.getElementById('ua-redirect-modal');
    if (!modal) return null;
    var badgeEl = modal.querySelector('[data-ua-redirect-badge]');
    var timerEl = modal.querySelector('[data-ua-redirect-timer]');
    var titleEl = modal.querySelector('[data-ua-redirect-title]');
    var bodyEl = modal.querySelector('[data-ua-redirect-body]');
    var stayBtn = modal.querySelector('[data-ua-redirect-stay]');
    var goBtn = modal.querySelector('[data-ua-redirect-go]');
    var actions = modal.querySelector('.ua-redirect__actions');

    if (badgeEl && visitorCountry) badgeEl.textContent = visitorCountry;
    if (titleEl) titleEl.textContent = COPY.title;
    if (bodyEl && timerEl) {
      bodyEl.innerHTML = '';
      if (UA_REDIRECT_AUTO_ENABLED && timerEl) {
        var prefix = document.createTextNode(COPY.body_prefix + ' ');
        var suffix = document.createTextNode(' ' + COPY.body_suffix);
        bodyEl.appendChild(prefix);
        bodyEl.appendChild(timerEl);
        bodyEl.appendChild(suffix);
      } else {
        var fallbackBody = COPY.body_no_auto || ((COPY.body_prefix || '') + (COPY.body_suffix ? ' ' + COPY.body_suffix : ''));
        bodyEl.textContent = fallbackBody;
        if (timerEl) timerEl.hidden = true;
      }
    }
    if (stayBtn) stayBtn.textContent = COPY.btn_stay;
    if (goBtn) goBtn.textContent = COPY.btn_go;
    if (!ALLOW_STAY && stayBtn) {
      stayBtn.remove();
      if (actions) {
        actions.style.gridTemplateColumns = '1fr';
      }
    }

    return {
      show: function() { modal.hidden = false; },
      hide: function() { modal.hidden = true; },
      timerEl: timerEl,
      stayBtn: stayBtn,
      goBtn: goBtn
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!UA_REDIRECT_ENABLED) return;
    if (handleBypassParam()) return;
    if (hasBypass()) return;
    if (!UA_REDIRECT_URL) return;

    detectCountry().then(function (visitorCountry) {
      if (!visitorCountry) return;
      if (visitorCountry === UA_CODE) return;

      var modal = buildModal(visitorCountry);
      if (!modal) return;

      var tick = null;
      var redirectTimeout = null;

      function cancelRedirect() {
        if (redirectTimeout) clearTimeout(redirectTimeout);
        if (tick) clearInterval(tick);
        modal.hide();
      }

      if (UA_REDIRECT_AUTO_ENABLED) {
        if (!REDIRECT_DELAY_MS || REDIRECT_DELAY_MS < 0) REDIRECT_DELAY_MS = 12000;

        var totalSeconds = Math.max(1, Math.round(REDIRECT_DELAY_MS / 1000));
        if (modal.timerEl) modal.timerEl.textContent = totalSeconds;
        modal.show();

        var remaining = totalSeconds;
        tick = setInterval(function () {
          remaining -= 1;
          if (remaining <= 0) {
            clearInterval(tick);
          }
          if (remaining >= 0 && modal.timerEl) {
            modal.timerEl.textContent = remaining;
          }
        }, 1000);

        redirectTimeout = setTimeout(function () {
          window.location.href = UA_REDIRECT_URL;
        }, REDIRECT_DELAY_MS);
      } else {
        modal.show();
      }

      if (modal.stayBtn) {
        modal.stayBtn.addEventListener('click', function () {
          setBypass();
          cancelRedirect();
        });
      }

      if (modal.goBtn) {
        modal.goBtn.addEventListener('click', function () {
          clearTimeout(redirectTimeout);
          window.location.href = UA_REDIRECT_URL;
        });
      }
    });
  });
})();
